import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';


import smsBatch from './batch';
import smsCronjob from './cronjob';
import smsTrigger from './trigger';

const System = ({ match }) => (
    <div className="dashboard-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/default`} />
            <Route path={`${match.url}/batch`} component={smsBatch} />
            <Route path={`${match.url}/cronjob`} component={smsCronjob} />
            <Route path={`${match.url}/trigger`} component={smsTrigger} />
            <Redirect to="/error" />
        </Switch>
    </div>
);
export default System;